/**
 * @file
 * Headline script.
 */

(function headlineScript($, Drupal, _) {
  'use strict';

  function updateLayout(id) {
    if (!id) {
      return;
    }

    var $headlineHeader = $('#' + id).find('.headline__header');
    var $headlineContent = $('#' + id).find('.headline__content');
    var $headlineSecondaryContent = $('#' + id).find('.headline__secondary-content');
    var $headlinePrimaryMedia = $('#' + id).find('.headline__primary-media');

    if ($(window).width() <= 767) {
      $headlineHeader.prepend($headlinePrimaryMedia);
      $headlineContent.append($headlineSecondaryContent);
      $('#' + id).attr('data-mobile-layout', 'true');
    }
    else {
      $headlineHeader.append($headlineSecondaryContent);
      $headlineContent.prepend($headlinePrimaryMedia);
      $('#' + id).attr('data-mobile-layout', 'false');
    }
  }

  Drupal.behaviors.headline = {
    attach: function (context) {
      if (!$('.headline--flexible-content', context).length) { return; }

      $('.headline--flexible-content', context).each(function () {
        if (($(window).width() > 767 && $(this).data('mobile-layout')) || ($(window).width() <= 767 && !$(this).data('mobile-layout'))) {
          updateLayout($(this).attr('id'));
        }
      });

      $(window).on('resize', _.throttle(function windowResize() {
        $('.headline--flexible-content', context).each(function () {
          var layoutBoolean = $(this).attr('data-mobile-layout');
          if (($(window).width() > 767 && layoutBoolean) || ($(window).width() <= 767 && layoutBoolean === 'false')) {
            updateLayout($(this).attr('id'));
          }
        });
      }, 400));
    }
  };
}(jQuery, Drupal, _));
